package com.milta.core.localization.translations.nl

import com.milta.core.localization.WebHistoriqueStrings

internal val WebHistorique = WebHistoriqueStrings(
    screenATitle = "Ritgeschiedenis",
    periodLabel = "Periode",
    periodLastEightDays = "Laatste 8 dagen",
    periodSingleDate = "Specifieke datum",
    periodRange = "Datumbereik",
    rangeFromLabel = "Van",
    rangeToLabel = "Tot",
    driverFilterLabel = "Chauffeur",
    driverFilterAllOption = "Alle chauffeurs",
    columnDate = "Datum",
    columnDriver = "Chauffeur",
    columnTotalDeliveries = "Totaal leveringen",
    columnDelivered = "Geleverd",
    columnFailed = "Mislukt",
    viewProofsAction = "Bewijzen bekijken",
    emptyHistoryMessage = "Geen ritten gevonden voor deze periode.",
    errorInvalidPeriod = "De geselecteerde periode is niet geldig.",
    screenBTitle = "Geschiedenis van leveringsbewijzen",
    routeOfLabel = "Rit van",
    totalDeliveriesLabel = "leveringen",
    deliveredLabel = "geleverd",
    failedLabel = "mislukt",
    backToHistoryAction = "Ritgeschiedenis",
    statusDeliveredBadge = "Geleverd",
    statusFailedBadge = "Mislukt",
    viewReasonAction = "Reden bekijken",
    hideReasonAction = "Reden verbergen",
    photoPlaceholderAlt = "Geen foto beschikbaar",
    photoAlt = "Leveringsbewijs",
    emptyProofsMessage = "Geen leveringsbewijs beschikbaar voor deze rit.",
    paginationPrevious = "Vorige",
    paginationNext = "Volgende",
)
